var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickGreencircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z",
    fill: "#3CAF47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93508 11.6842C7.78508 11.6842 7.64258 11.6242 7.53758 11.5192L5.41508 9.39672C5.19758 9.17922 5.19758 8.81922 5.41508 8.60172C5.63258 8.38422 5.99258 8.38422 6.21008 8.60172L7.93508 10.3267L11.7901 6.47172C12.0076 6.25422 12.3676 6.25422 12.5851 6.47172C12.8026 6.68922 12.8026 7.04922 12.5851 7.26672L8.33258 11.5192C8.22758 11.6242 8.08508 11.6842 7.93508 11.6842Z",
    fill: "#3CAF47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreencircle);
export default __webpack_public_path__ + "static/media/tick-greencircle.ef10693dce648a7a4e0af5572e111d86.svg";
export { ForwardRef as ReactComponent };